import { StaticPageUrls } from '../../../api/analytics/ClientEvents';
import { Backend } from '../../../api/Backend';
import { EpgGuideChannelDataSource } from './EpgGuideChannelDataSource';
import { ChannelManager } from '../../../api/ChannelManager';

export class EpgGuideDataSource {
  private channelDatasources: EpgGuideChannelDataSource[] = [];
  private readonly backend: Backend;

  constructor(backend: Backend) {
    this.backend = backend;
  }

  loadChannels(): Promise<EpgGuideChannelDataSource[]> {
    return ChannelManager.validChannels(this.backend, false).then(channels => {
      const validChannels = channels.validChannels;
      // map data to new EpgGuideChannelDataSource
      this.channelDatasources = validChannels.map(el => new EpgGuideChannelDataSource(this.backend, el));

      // sort based on channelNumber
      function compare(a: EpgGuideChannelDataSource, b: EpgGuideChannelDataSource) {
        if (a.getChannelNumber() < b.getChannelNumber()) {
          return -1;
        }
        if (a.getChannelNumber() > b.getChannelNumber()) {
          return 1;
        }
        return 0;
      }

      this.channelDatasources.sort(compare);

      // put favorite channels first
      const favPromises = this.channelDatasources.map(el => el.updateFavorite());
      return Promise.all(favPromises).then(() => {
        const favs = this.channelDatasources.filter(el => el.isFavorite());
        const other = this.channelDatasources.filter(el => !el.isFavorite());
        this.channelDatasources = favs.concat(other);
        return this.channelDatasources;
      });
    });
  }

  logPageView(title: string) {
    this.backend.logService.trackPageView(StaticPageUrls.epgGuide, title);
  }
}
